import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { EventService } from "../event-service/event.service";
import { KeyboardService } from "../keyboard/keyboard.service";
import { OnboardingTaskStateService } from "./onboarding-task-state.service";

@Component({
  selector: "ab-onboarding-checklist",
  templateUrl: "./onboarding-checklist.component.html",
})
export class OnboardingChecklistComponent implements OnInit, OnDestroy {
  @Input() public project: any;
  @Input() public user: any;

  public showChecklist: boolean;

  private unregisterKeydown: any;
  private showChecklistSub: any;
  private dismissedCalloutSub: any;

  constructor(
    private eventService: EventService,
    private keyboardService: KeyboardService,
    private onboardingTaskStateService: OnboardingTaskStateService,
  ) {}

  public ngOnInit() {
    this.showChecklist = false;
    this.onboardingTaskStateService
      .initForProject(this.project)
      .subscribe(() => {
        this.hideOrShowIndicator();
      });

    this.unregisterKeydown = this.keyboardService.onKeydown(
      (event: KeyboardEvent) => {
        // Allow dismissing of checklist with ESC key
        if (event.code === "Escape" && this.showChecklist) {
          return this.close();
        }
      },
    );

    this.showChecklistSub = this.eventService.subscribe(
      "show-checklist",
      (show: boolean) => {
        if (this.showChecklist === show) {
          return;
        }
        show ? this.open() : this.closeChecklist();
      },
    );

    // Dismissing a callout sends it to the checklist. If it was hidden, we may
    // now need to show it to reflect that it now has tasks.
    this.dismissedCalloutSub = this.eventService.subscribe(
      "dismissed-callout",
      () => {
        this.hideOrShowIndicator();
      },
    );
  }

  public ngOnDestroy() {
    this.unregisterKeydown();
    this.showChecklistSub.unsubscribe();
    this.dismissedCalloutSub.unsubscribe();
  }

  public trackByIndex(index: number, _item: any) {
    return index;
  }

  public tasks() {
    return this.onboardingTaskStateService.checklistTasks;
  }

  public checklistCount() {
    return this.onboardingTaskStateService.checklistTasks.length;
  }

  public completedCount() {
    return this.onboardingTaskStateService.completedCount;
  }

  public close() {
    this.closeChecklist();
  }

  public open() {
    this.showChecklist = true;
    this.hideOrShowIndicator();
  }

  // Hide/show the nav bar progress widget and the user dropdown dot indicator.
  private hideOrShowIndicator() {
    const hasTasks = this.checklistCount() > this.completedCount();
    const show = hasTasks && !this.showChecklist;
    this.eventService.publish("indicator-visibility", show);
  }

  private closeChecklist() {
    this.showChecklist = false;
    this.eventService.publish("checklist-visibility", false);
    this.hideOrShowIndicator();
  }
}
